import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LazyLoadDirective } from '@banyan/commons/directives/lazy-load.directive';

@Component({
  selector: 'app-trend-article-card',
  templateUrl: './trend-article-card.component.html',
  styleUrls: ['./trend-article-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, LazyLoadDirective],
})
export class TrendArticleCardComponent {
  @Input() title: string | undefined = '';
  @Input() abstract: string | undefined = '';
  @Input() set image(link: string | undefined) {
    this.backgroundImage = `${link}`;
  }
  @Input() displayStyle: 'main' | 'default' = 'default';
  @Input() url: string | undefined = '';

  backgroundImage = '';

  constructor(private readonly router: Router) {}

  redirectToArticle(url: string | undefined): void {
    if (url) {
      this.router.navigate([url]);
    }
  }
}
